module.exports = __webpack_public_path__ + "static/media/icon-arrow.7eba7540.svg";